(function () {
  function init() {
  var root = document.getElementById('SpiceHelpWidget');
  if (!root) return;
  if (root.dataset.spiceHelpReady === 'true') return;

  var apiBase = root.dataset.apiBase || '';
  var whatsappUrl = root.dataset.whatsappUrl || 'https://api.whatsapp.com/send/?phone=%2B493089657586&type=phone_number&app_absent=0';
  var customerEmail = (root.dataset.customerEmail || '').trim().toLowerCase();
  var customerName = (root.dataset.customerName || '').trim();
  var launcher = root.querySelector('.spice-help__launcher');
  var panel = root.querySelector('.spice-help__panel');
  var backdrop = root.querySelector('.spice-help__backdrop');
  var body = root.querySelector('[data-spice-help-body]');
  var backButton = root.querySelector('[data-spice-help-back]');
  var closeButton = root.querySelector('[data-spice-help-close]');

  var state = {
    screen: 'menu',
    history: [],
    order: null,
    orderItems: [],
    selectedItems: [],
    damageImage: null,
    email: customerEmail,
    orderNumber: '',
  };

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function emailLooksValid(value) {
    return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(value || '').trim());
  }

  function iconSvg(name) {
    var icons = {
      whatsapp: '<svg aria-hidden="true" viewBox="0 0 24 24" focusable="false"><path d="M5.5 19.2 6.6 16A7 7 0 1 1 9 18.1l-3.5 1.1Z" /><path d="M9.3 8.8c.2-.4.4-.4.7-.4h.5c.2 0 .4.1.5.4l.7 1.5c.1.2.1.4 0 .6l-.4.5c-.1.1-.2.3-.1.5.4.8 1.1 1.5 2 2 .2.1.4 0 .5-.1l.6-.7c.2-.2.4-.2.6-.1l1.5.7c.3.1.4.3.4.6 0 .5-.2 1-.6 1.3-.4.3-1 .5-1.8.3-2.8-.7-5.1-2.8-6-5.5-.2-.8 0-1.4.4-1.8Z" /></svg>',
      email: '<svg aria-hidden="true" viewBox="0 0 24 24" focusable="false"><path d="M4 6h16v12H4z" /><path d="m4 7 8 6 8-6" /></svg>',
      package: '<svg aria-hidden="true" viewBox="0 0 24 24" focusable="false"><path d="m3 7 9-4 9 4-9 4-9-4Z" /><path d="M3 7v10l9 4 9-4V7" /><path d="M12 11v10" /></svg>',
      damage: '<svg aria-hidden="true" viewBox="0 0 24 24" focusable="false"><path d="M12 3 3 8l9 5 9-5-9-5Z" /><path d="M5 10v6l7 5 7-5v-6" /><path d="m9 7 3 2 3-2" /><path d="m9 15 6-3" /></svg>',
      chat: '<svg aria-hidden="true" viewBox="0 0 24 24" focusable="false"><path d="M5 6h14v10H8l-3 3V6Z" /><path d="M9 10h6" /><path d="M9 13h4" /></svg>',
    };
    return icons[name] || '';
  }

  function menuOptionHtml(next, icon, title, text) {
    return [
      '<button class="spice-help__choice spice-help__menu-option" type="button" data-next="' + escapeHtml(next) + '">',
      '<span class="spice-help__contact-icon">' + iconSvg(icon) + '</span>',
      '<span class="spice-help__option-copy">',
      '<strong>' + escapeHtml(title) + '</strong>',
      '<small>' + escapeHtml(text) + '</small>',
      '</span>',
      '</button>',
    ].join('');
  }

  function setTitle(title) {
    var titleNode = root.querySelector('.spice-help__title');
    if (titleNode) titleNode.textContent = title || 'How can we help?';
  }

  function openPanel() {
    panel.hidden = false;
    launcher.setAttribute('aria-expanded', 'true');
    if (window.matchMedia('(max-width: 749px)').matches) {
      backdrop.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }
    render('menu', { replace: true });
  }

  function togglePanel() {
    if (panel.hidden) {
      openPanel();
    } else {
      closePanel();
    }
  }

  function closePanel() {
    panel.hidden = true;
    backdrop.hidden = true;
    launcher.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    launcher.focus();
  }

  function isCartDrawerActive() {
    var cartDrawer = document.querySelector('cart-drawer');
    return !!(cartDrawer && (cartDrawer.hasAttribute('active') || cartDrawer.hasAttribute('open')));
  }

  function syncCartDrawerState() {
    root.classList.toggle('spice-help--cart-drawer-active', isCartDrawerActive());
  }

  function render(screen, opts) {
    opts = opts || {};
    if (!opts.replace && state.screen && state.screen !== screen) {
      state.history.push(state.screen);
    }
    state.screen = screen;
    backButton.hidden = state.history.length === 0 || screen === 'menu';
    body.innerHTML = screens[screen] ? screens[screen]() : screens.menu();
    bindScreen(screen);
  }

  function goBack() {
    var prev = state.history.pop();
    render(prev || 'menu', { replace: true });
  }

  function setLoading(button, loadingText) {
    if (!button) return function () {};
    var old = button.innerHTML;
    button.disabled = true;
    button.innerHTML = '<span class="spice-help__spinner" aria-hidden="true"></span>' + escapeHtml(loadingText || 'Working...');
    return function () {
      button.disabled = false;
      button.innerHTML = old;
    };
  }

  async function postJson(path, payload) {
    var response = await fetch(apiBase + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    var data = await response.json().catch(function () { return {}; });
    if (!response.ok) {
      throw new Error(data.detail || data.message || 'Something went wrong');
    }
    return data;
  }

  async function postForm(path, formData) {
    var response = await fetch(apiBase + path, {
      method: 'POST',
      body: formData,
    });
    var data = await response.json().catch(function () { return {}; });
    if (!response.ok) {
      throw new Error(data.detail || data.message || 'Something went wrong');
    }
    return data;
  }

  function orderFieldsHtml(buttonText) {
    return [
      '<form class="spice-help__form" data-order-form>',
      '<div class="spice-help__field">',
      '<label class="spice-help__label" for="SpiceHelpOrder">Order number</label>',
      '<input class="spice-help__input" id="SpiceHelpOrder" name="order_number" inputmode="numeric" autocomplete="off" placeholder="Example: 135127" value="' + escapeHtml(state.orderNumber) + '">',
      '</div>',
      '<div class="spice-help__field">',
      '<label class="spice-help__label" for="SpiceHelpEmail">Email used at checkout</label>',
      '<input class="spice-help__input" id="SpiceHelpEmail" name="email" type="email" autocomplete="email" placeholder="you@example.com" value="' + escapeHtml(state.email) + '">',
      customerEmail ? '<p class="spice-help__fineprint">We filled this from your account. You can change it.</p>' : '',
      '</div>',
      '<p class="spice-help__error" data-error hidden></p>',
      '<button class="spice-help__button spice-help__button--primary" type="submit">' + escapeHtml(buttonText) + '</button>',
      '</form>',
    ].join('');
  }

  function statusCard(order) {
    var hasTracking = !!(order && (order.tracking_number || order.tracking_url));
    var shippingMethod = order && order.shipping_method ? String(order.shipping_method) : '';
    var isSameDay = /same[\s-]?day|berlin/i.test(shippingMethod);
    if (hasTracking) {
      return [
        '<div class="spice-help__notice spice-help__notice--success">',
        '<p class="spice-help__notice-title">Good news, your order is on the way.</p>',
        '<dl class="spice-help__meta">',
        '<div class="spice-help__meta-row"><dt>Tracking</dt><dd><strong>' + escapeHtml(order.tracking_number || 'Available') + '</strong></dd></div>',
        order.carrier ? '<div class="spice-help__meta-row"><dt>Carrier</dt><dd><strong>' + escapeHtml(order.carrier) + '</strong></dd></div>' : '',
        order.shipping_method ? '<div class="spice-help__meta-row"><dt>Shipping</dt><dd><strong>' + escapeHtml(order.shipping_method) + '</strong></dd></div>' : '',
        '</dl>',
        order.tracking_url ? '<a class="spice-help__link-button" href="' + escapeHtml(order.tracking_url) + '" target="_blank" rel="noopener noreferrer">Track package</a>' : '',
        '</div>',
      ].join('');
    }
    return [
      '<div class="spice-help__notice">',
      '<p class="spice-help__notice-title">' + (isSameDay ? 'Your order was fulfilled.' : 'Your order is confirmed.') + '</p>',
      '<p class="spice-help__subcopy">' + (isSameDay ? 'For same-day orders, please check your email to get updates.' : 'Tracking is not available yet. You will receive updates by email.') + '</p>',
      order.shipping_method ? '<dl class="spice-help__meta"><div class="spice-help__meta-row"><dt>Shipping</dt><dd><strong>' + escapeHtml(order.shipping_method) + '</strong></dd></div></dl>' : '',
      '</div>',
    ].join('');
  }

  var screens = {
    menu: function () {
      setTitle('How can we help?');
      return [
        '<div class="spice-help__screen">',
        '<p class="spice-help__copy">Hi, how can we help today?</p>',
        '<div class="spice-help__menu">',
        menuOptionHtml('track', 'package', 'Track my order', 'Check tracking and delivery updates'),
        menuOptionHtml('damage-intro', 'damage', 'Report a damaged item', 'Send us the item and photo'),
        menuOptionHtml('human', 'chat', 'Talk to us', 'WhatsApp or email support'),
        '</div>',
        '<p class="spice-help__fineprint">We will use your details only to help with your Spice Village order.</p>',
        '</div>',
      ].join('');
    },
    track: function () {
      setTitle('Track my order');
      return [
        '<div class="spice-help__screen">',
        '<p class="spice-help__copy">Sure, I can check that for you. Please enter your order number and the email used at checkout.</p>',
        orderFieldsHtml('Check order'),
        '<div class="spice-help__actions"><button class="spice-help__small-action" type="button" data-next="human">I would rather contact the team</button></div>',
        '</div>',
      ].join('');
    },
    'track-result': function () {
      setTitle('Order update');
      return [
        '<div class="spice-help__screen">',
        statusCard(state.order),
        '<p class="spice-help__copy">Need anything else about this order?</p>',
        '<div class="spice-help__actions">',
        '<button class="spice-help__button spice-help__button--primary" type="button" data-next="order-question">Ask our team</button>',
        '<button class="spice-help__button" type="button" data-next="menu" data-reset-history="true">Back to menu</button>',
        '</div>',
        '</div>',
      ].join('');
    },
    'order-question': function () {
      setTitle('Ask our team');
      return [
        '<div class="spice-help__screen">',
        '<p class="spice-help__copy">What would you like to ask about this order?</p>',
        '<form class="spice-help__form" data-question-form>',
        '<textarea class="spice-help__textarea" name="message" maxlength="2000" placeholder="Write your question here"></textarea>',
        '<p class="spice-help__error" data-error hidden></p>',
        '<button class="spice-help__button spice-help__button--primary" type="submit">Send to team</button>',
        '</form>',
        '</div>',
      ].join('');
    },
    'damage-intro': function () {
      setTitle('Damaged item');
      return [
        '<div class="spice-help__screen spice-help__screen--intro">',
        '<div class="spice-help__notice spice-help__notice--warm">',
        '<span class="spice-help__notice-icon">' + iconSvg('damage') + '</span>',
        '<p class="spice-help__notice-title">Hey there, we are sorry that you received a damaged item.</p>',
        '<p class="spice-help__subcopy">We are committed to providing fresh groceries always. If something unexpected happened, we are always happy to help.</p>',
        '<p class="spice-help__subcopy">Fill out the form with your details and we will get back to you in a jiffy.</p>',
        '</div>',
        '<div class="spice-help__actions">',
        '<button class="spice-help__button spice-help__button--primary" type="button" data-next="damage-order">Start request</button>',
        '<button class="spice-help__button" type="button" data-next="human">Contact team instead</button>',
        '</div>',
        '</div>',
      ].join('');
    },
    'damage-order': function () {
      setTitle('Find your order');
      return [
        '<div class="spice-help__screen">',
        '<p class="spice-help__copy">Please enter your order number and the email used at checkout.</p>',
        orderFieldsHtml('Find order'),
        '</div>',
      ].join('');
    },
    'damage-items': function () {
      setTitle('Select item');
      var items = state.orderItems.map(function (item, index) {
        var purchasedQuantity = Math.max(1, Number(item.quantity || 1));
        return [
          '<div class="spice-help__item">',
          '<label class="spice-help__item-main">',
          '<input type="checkbox" value="' + index + '" data-damage-item>',
          '<span>',
          '<p class="spice-help__item-name">' + escapeHtml(item.name) + '</p>',
          '<p class="spice-help__item-qty">Purchased quantity: ' + escapeHtml(purchasedQuantity) + '</p>',
          '</span>',
          '</label>',
          purchasedQuantity > 1
            ? '<label class="spice-help__damage-qty"><span>Damaged quantity</span><input class="spice-help__qty-input" type="number" min="1" max="' + escapeHtml(purchasedQuantity) + '" value="1" inputmode="numeric" data-damage-qty="' + index + '" disabled></label>'
            : '',
          '</div>',
        ].join('');
      }).join('');
      return [
        '<div class="spice-help__screen">',
        '<p class="spice-help__copy">Which item arrived damaged? If you bought more than one, tell us how many were damaged.</p>',
        '<div class="spice-help__item-list">' + items + '</div>',
        '<p class="spice-help__error" data-error hidden></p>',
        '<div class="spice-help__actions">',
        '<button class="spice-help__button spice-help__button--primary" type="button" data-continue-items>Continue</button>',
        '</div>',
        '</div>',
      ].join('');
    },
    'damage-photo': function () {
      setTitle('Upload photo');
      var preview = state.damageImage ? '<img class="spice-help__preview" src="' + escapeHtml(URL.createObjectURL(state.damageImage)) + '" alt="Selected damaged item photo">' : '<span><strong>Upload a clear photo</strong><br><small>JPEG, PNG, WebP, HEIC. Max 8 MB.</small></span>';
      return [
        '<div class="spice-help__screen">',
        '<p class="spice-help__copy">Please upload a clear photo of the damaged item.</p>',
        '<div class="spice-help__upload">',
        '<label class="spice-help__file-drop">',
        '<input type="file" accept="image/jpeg,image/png,image/webp,image/heic,image/heif" data-damage-file>',
        preview,
        '</label>',
        '</div>',
        '<p class="spice-help__error" data-error hidden></p>',
        '<div class="spice-help__actions">',
        '<button class="spice-help__button spice-help__button--primary" type="button" data-continue-photo>Continue</button>',
        '<button class="spice-help__small-action" type="button" data-next="human">I would rather send this to the team</button>',
        '</div>',
        '</div>',
      ].join('');
    },
    'damage-note': function () {
      setTitle('Almost done');
      return [
        '<div class="spice-help__screen">',
        '<p class="spice-help__copy">Anything else we should know?</p>',
        '<form class="spice-help__form" data-damage-submit>',
        '<textarea class="spice-help__textarea" name="note" maxlength="2000" placeholder="Optional"></textarea>',
        '<p class="spice-help__error" data-error hidden></p>',
        '<button class="spice-help__button spice-help__button--primary" type="submit">Submit request</button>',
        '</form>',
        '</div>',
      ].join('');
    },
    human: function () {
      setTitle('Talk to us');
      return [
        '<div class="spice-help__screen">',
        '<p class="spice-help__copy">Of course. How would you like to reach us?</p>',
        '<div class="spice-help__menu">',
        '<a class="spice-help__link-button spice-help__contact-option" href="' + escapeHtml(whatsappUrl) + '" target="_blank" rel="noopener noreferrer"><span class="spice-help__contact-icon">' + iconSvg('whatsapp') + '</span><span class="spice-help__contact-text">WhatsApp</span></a>',
        '<button class="spice-help__choice spice-help__contact-option" type="button" data-next="email-contact"><span class="spice-help__contact-icon">' + iconSvg('email') + '</span><span class="spice-help__contact-text">Email</span></button>',
        '</div>',
        '<p class="spice-help__subcopy">If you choose WhatsApp, we will pick it up there.</p>',
        '</div>',
      ].join('');
    },
    'email-contact': function () {
      setTitle('Email');
      return [
        '<div class="spice-help__screen">',
        '<p class="spice-help__copy">Send us your message and we will reply by email.</p>',
        '<form class="spice-help__form" data-contact-form>',
        '<div class="spice-help__field"><label class="spice-help__label" for="SpiceHelpName">Name</label><input class="spice-help__input" id="SpiceHelpName" name="name" autocomplete="name" value="' + escapeHtml(customerName) + '"></div>',
        '<div class="spice-help__field"><label class="spice-help__label" for="SpiceHelpContactEmail">Email</label><input class="spice-help__input" id="SpiceHelpContactEmail" name="email" type="email" autocomplete="email" value="' + escapeHtml(state.email) + '"></div>',
        '<div class="spice-help__field"><label class="spice-help__label" for="SpiceHelpContactOrder">Order number, optional</label><input class="spice-help__input" id="SpiceHelpContactOrder" name="order_number" inputmode="numeric" value="' + escapeHtml(state.orderNumber) + '"></div>',
        '<div class="spice-help__field"><label class="spice-help__label" for="SpiceHelpMessage">Message</label><textarea class="spice-help__textarea" id="SpiceHelpMessage" name="message" maxlength="2000"></textarea></div>',
        '<p class="spice-help__error" data-error hidden></p>',
        '<button class="spice-help__button spice-help__button--primary" type="submit">Send message</button>',
        '</form>',
        '</div>',
      ].join('');
    },
    done: function () {
      setTitle('We have got it');
      return [
        '<div class="spice-help__screen">',
        '<div class="spice-help__notice spice-help__notice--success">',
        '<p class="spice-help__notice-title">Thanks, we have got it.</p>',
        '<p class="spice-help__subcopy">Our team will reply by email.</p>',
        '</div>',
        '<div class="spice-help__actions">',
        '<button class="spice-help__button spice-help__button--primary" type="button" data-next="menu" data-reset-history="true">Back to menu</button>',
        '<button class="spice-help__button" type="button" data-close>Close</button>',
        '</div>',
        '</div>',
      ].join('');
    },
    damageDone: function () {
      setTitle('Request received');
      return [
        '<div class="spice-help__screen">',
        '<div class="spice-help__notice spice-help__notice--success">',
        '<p class="spice-help__notice-title">Thank you, we have received your request and photo.</p>',
        '<p class="spice-help__subcopy">Our team will review it and get back to you within 48 hours.</p>',
        '</div>',
        '<div class="spice-help__actions">',
        '<button class="spice-help__button spice-help__button--primary" type="button" data-next="menu" data-reset-history="true">Back to menu</button>',
        '<button class="spice-help__button" type="button" data-close>Close</button>',
        '</div>',
        '</div>',
      ].join('');
    },
  };

  function showError(formOrBody, message) {
    var error = formOrBody.querySelector('[data-error]');
    if (error) {
      error.textContent = message || 'Something went wrong. Please try again.';
      error.hidden = false;
    }
  }

  function readOrderForm(form) {
    var orderNumber = (form.elements.order_number.value || '').trim().replace(/[^0-9]/g, '');
    var email = (form.elements.email.value || '').trim().toLowerCase();
    if (!orderNumber) throw new Error('Please enter your order number.');
    if (!emailLooksValid(email)) throw new Error('Please enter a valid email address.');
    state.orderNumber = orderNumber;
    state.email = email;
    return { order_number: orderNumber, email: email, website_customer_email: customerEmail || null };
  }

  function bindScreen(screen) {
    body.querySelectorAll('[data-next]').forEach(function (button) {
      button.addEventListener('click', function () {
        var next = button.getAttribute('data-next');
        if (button.getAttribute('data-reset-history') === 'true') state.history = [];
        render(next, next === 'menu' ? { replace: true } : undefined);
      });
    });
    body.querySelectorAll('[data-close]').forEach(function (button) {
      button.addEventListener('click', closePanel);
    });

    var orderForm = body.querySelector('[data-order-form]');
    if (orderForm) {
      orderForm.addEventListener('submit', async function (event) {
        event.preventDefault();
        var restore = setLoading(orderForm.querySelector('button[type="submit"]'), 'Checking...');
        try {
          var payload = readOrderForm(orderForm);
          var path = screen === 'damage-order' ? '/damaged-product/order' : '/order-status';
          var data = await postJson(path, payload);
          state.order = data.order;
          state.orderItems = data.items || [];
          if (screen === 'damage-order') {
            if (!state.orderItems.length) {
              showError(orderForm, 'We found the order, but could not load the item list. Please contact the team.');
              return;
            }
            render('damage-items');
          } else {
            render('track-result');
          }
        } catch (error) {
          showError(orderForm, error.message === 'Order not found for that email'
            ? 'I could not find that order with this email. Please check both details, or ask our team to help.'
            : error.message);
        } finally {
          restore();
        }
      });
    }

    var questionForm = body.querySelector('[data-question-form]');
    if (questionForm) {
      questionForm.addEventListener('submit', async function (event) {
        event.preventDefault();
        var message = (questionForm.elements.message.value || '').trim();
        if (!message) {
          showError(questionForm, 'Please write your question so our team can help.');
          return;
        }
        var restore = setLoading(questionForm.querySelector('button[type="submit"]'), 'Sending...');
        try {
          await postJson('/order-question', {
            order_number: state.orderNumber,
            email: state.email,
            website_customer_email: customerEmail || null,
            message: message,
          });
          state.history = [];
          render('done', { replace: true });
        } catch (error) {
          showError(questionForm, 'We could not send this right now. Please try again or contact us on WhatsApp.');
        } finally {
          restore();
        }
      });
    }

    var continueItems = body.querySelector('[data-continue-items]');
    if (continueItems) {
      body.querySelectorAll('[data-damage-item]').forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
          var qtyInput = body.querySelector('[data-damage-qty="' + checkbox.value + '"]');
          if (qtyInput) qtyInput.disabled = !checkbox.checked;
        });
      });
      continueItems.addEventListener('click', function () {
        var checked = Array.prototype.slice.call(body.querySelectorAll('[data-damage-item]:checked'));
        state.selectedItems = checked.map(function (input) {
          var index = Number(input.value);
          var item = state.orderItems[index];
          if (!item) return null;
          var purchasedQuantity = Math.max(1, Number(item.quantity || 1));
          var qtyInput = body.querySelector('[data-damage-qty="' + index + '"]');
          var damagedQuantity = qtyInput ? Number(qtyInput.value || 1) : 1;
          damagedQuantity = Math.max(1, Math.min(purchasedQuantity, damagedQuantity));
          return Object.assign({}, item, {
            purchased_quantity: purchasedQuantity,
            damaged_quantity: damagedQuantity,
          });
        }).filter(Boolean);
        if (!state.selectedItems.length) {
          showError(body, 'Please select the damaged item so we can review the right product.');
          return;
        }
        render('damage-photo');
      });
    }

    var fileInput = body.querySelector('[data-damage-file]');
    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var file = fileInput.files && fileInput.files[0];
        if (!file) return;
        if (file.size > 8 * 1024 * 1024) {
          showError(body, 'The image is too large. Please upload an image up to 8 MB.');
          return;
        }
        state.damageImage = file;
        render('damage-photo', { replace: true });
      });
    }

    var continuePhoto = body.querySelector('[data-continue-photo]');
    if (continuePhoto) {
      continuePhoto.addEventListener('click', function () {
        if (!state.damageImage) {
          showError(body, 'Please upload a clear photo before continuing.');
          return;
        }
        render('damage-note');
      });
    }

    var damageSubmit = body.querySelector('[data-damage-submit]');
    if (damageSubmit) {
      damageSubmit.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (!state.damageImage || !state.selectedItems.length) {
          showError(damageSubmit, 'Please select the item and upload a photo first.');
          return;
        }
        var formData = new FormData();
        formData.append('order_number', state.orderNumber);
        formData.append('email', state.email);
        formData.append('website_customer_email', customerEmail || '');
        formData.append('selected_items', JSON.stringify(state.selectedItems));
        formData.append('note', (damageSubmit.elements.note.value || '').trim());
        formData.append('image', state.damageImage);
        var restore = setLoading(damageSubmit.querySelector('button[type="submit"]'), 'Submitting...');
        try {
          await postForm('/damaged-product', formData);
          state.history = [];
          state.selectedItems = [];
          state.damageImage = null;
          render('damageDone', { replace: true });
        } catch (error) {
          showError(damageSubmit, 'We could not submit this right now. Please try again or contact us on WhatsApp.');
        } finally {
          restore();
        }
      });
    }

    var contactForm = body.querySelector('[data-contact-form]');
    if (contactForm) {
      contactForm.addEventListener('submit', async function (event) {
        event.preventDefault();
        var email = (contactForm.elements.email.value || '').trim().toLowerCase();
        var message = (contactForm.elements.message.value || '').trim();
        if (!emailLooksValid(email) || !message) {
          showError(contactForm, 'Please add your email and message so we can reply.');
          return;
        }
        var restore = setLoading(contactForm.querySelector('button[type="submit"]'), 'Sending...');
        try {
          await postJson('/contact', {
            name: (contactForm.elements.name.value || '').trim(),
            email: email,
            order_number: (contactForm.elements.order_number.value || '').trim(),
            message: message,
            website_customer_email: customerEmail || null,
          });
          state.email = email;
          state.history = [];
          render('done', { replace: true });
        } catch (error) {
          showError(contactForm, 'We could not send this right now. Please try again or contact us on WhatsApp.');
        } finally {
          restore();
        }
      });
    }
  }

  launcher.addEventListener('click', togglePanel);
  closeButton.addEventListener('click', closePanel);
  backdrop.addEventListener('click', closePanel);
  backButton.addEventListener('click', goBack);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !panel.hidden) closePanel();
  });

  syncCartDrawerState();
  var cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && window.MutationObserver) {
    var cartDrawerObserver = new MutationObserver(syncCartDrawerState);
    cartDrawerObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['active', 'open', 'hidden'] });
  }
  document.addEventListener('cart:refresh', function () {
    window.setTimeout(syncCartDrawerState, 0);
  });
  document.addEventListener('drawer:handleAfterShow', syncCartDrawerState);
  document.addEventListener('drawer:handleAfterHide', syncCartDrawerState);
  root.dataset.spiceHelpReady = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('pageshow', init);
})();
